function fn_comp_visual() {
	$('.visual-slides').slick({
		autoplay: true,
		fade: true,
		autoplaySpeed: 5000,
		prevArrow: '<button type="button" class="slick-prev icon--chevron-left"></button>',
    	nextArrow: '<button type="button" class="slick-next icon--chevron-right"></button>',
	});
}